<template>
  <section>
    <validation-observer v-slot="{invalid}">
      <b-row>
        <!-- 踏切名 -->
        <b-col cols="4">
          <validation-provider
            v-slot="validationContext"
            rules="max:100"
            name="踏切名"
          >
            <b-form-group label="踏切名">
              <b-form-input
                id="crossingName"
                v-model="searchCrossingName"
                maxlength="100"
                :state="getValidationState(validationContext)"
                autocomplete="off"
              >
              </b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- 発生日時 -->
        <b-col cols="6">
          <b-form-group label="発生日時">
            <b-row no-gutters>
              <!-- From -->
              <b-col cols="5">
                <date-picker
                  v-model="searchAlertDateFrom"
                  :config="datePickerOptions"
                >
                </date-picker>
              </b-col>
              <b-col cols="1" class="mx-auto">
                <span class="h1 text-secondary">～</span>
              </b-col>
              <!-- To -->
              <b-col cols="5">
                <date-picker
                  v-model="searchAlertDateTo"
                  :config="datePickerOptions"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-0">
        <!-- 発報元 -->
        <b-col cols="2">
          <b-form-group label="発報元">
            <b-form-checkbox-group
              id="searchReporterCheckbox"
              v-model="searchReporterSelected"
              :options="searchReporterOptions"
              name="reporter">
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <!-- 試運用フラグ -->
        <b-col cols="2">
          <b-form-group label="試運用フラグ">
            <b-form-checkbox
              id="searchTrialCheckbox"
              v-model="searchTrialSelected"
              name="trial">
              <span>試運用</span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <!-- 解除日時 -->
        <b-col cols="6">
          <b-form-group label="解除日時">
            <b-row no-gutters>
              <!-- From -->
              <b-col cols="5">
                <date-picker
                  v-model="searchCanselDateFrom"
                  :config="datePickerOptions"
                >
                </date-picker>
              </b-col>
              <b-col cols="1" class="mx-auto">
                <span class="h1 text-secondary">～</span>
              </b-col>
              <!-- To -->
              <b-col cols="5">
                <date-picker
                  v-model="searchCanselDateTo"
                  :config="datePickerOptions"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col cols="2" class="p-0 text-right">
          <!-- クリアボタン -->
          <b-button
            @click="clearSearchConditions()"
            v-show="showClearButton"
            variant="danger"
            size="lg"
            class="mr-1 mt-5">
            <span>クリア</span>
          </b-button>
          <!-- 検索ボタン -->
          <b-button
            @click="search()"
            variant="primary"
            size="lg"
            class="mt-5"
            :disabled="invalid"
            >
            <span>検索</span>
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </section>
</template>

<script>
  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker'
  // Import date picker css
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import moment from 'moment'

  export default {
    components: {datePicker},
    data() {
      return {
        // 検索条件の初期値
        searchCrossingName: null,
        searchAlertDateFrom: null,
        searchAlertDateTo: null,
        searchCanselDateFrom: null,
        searchCanselDateTo: null,
        searchReporterSelected: [
          '0',
          '2',
          '4',
        ],
        searchReporterOptions: [
          { text: 'AIカメラ検知', value: '0'},
          { text: '障検動作', value: '2'},
          { text: '押しボタン操作', value: '4'},
        ],
        searchTrialSelected: false,
        // クリアボタンの表示
        showClearButton: false,
        datePickerOptions: {
          format: 'YYYY/MM/DD HH:mm',
          useCurrent: false,
          showClear: true,
          locale: moment.locale('ja'),
          showTodayButton: true,
        },
      }
    },
    name: "AlertHistoryFilter",
    computed: {},
    methods: {
      // 検索ボタン押下時
      async search() {
        this.showClearButton = true
        this.$emit('msgShow', true, this.searchCrossingName, this.searchAlertDateFrom, this.searchAlertDateTo,
          this.searchReporterSelected, (this.searchTrialSelected == true ? 1 : 0), this.searchCanselDateFrom, this.searchCanselDateTo)
      },
      // クリアボタン押下時
      clearSearchConditions() {
        this.showClearButton = false

        // 検索条件の初期化
        this.searchCrossingName = null
        this.searchAlertDateFrom = null
        this.searchAlertDateTo = null
        this.searchCanselDateFrom = null
        this.searchCanselDateTo = null
        this.searchReporterSelected = [
          '0',
          '2',
          '4',
        ]
        this.searchTrialSelected = false
        this.$emit('msgShow', false)

      },

      getValidationState: ({dirty, validated, valid = null}) => dirty || validated ? valid : null,
    },
  }
</script>

<style scoped>
  .div_float:after {
    content:'';
    display:table;
    clear:both;
  }
  .div_float .cell {
    border: none;
    float: left;
    width:200px;
  }
</style>
